import { ServiceOfferAvailability } from "../graphql/schema";

export function hasAvailableOffers(offers: ({ availability: keyof typeof ServiceOfferAvailability } | undefined)[]) {
  return offers.length > 0 && offers.some((off) => off && off.availability !== "UNAVAILABLE_FOR_COUNTRY");
}
